jQuery(function($){
  $(document).on('nfFormReady', function(){
    // Init select2 on ninja forms select fields
    $('select.ninja-forms-field').each(function(){
      $(this).select2({
        placeholder: "Objet",
        minimumResultsForSearch: Infinity,
        dropdownParent: $(this).parent(),
      });
    });

    // zipcode->city autocomplete
    initZipcodeCityAutocomplete();

    // Set cursor to start of input when value is only filled with mask characters
    initTextMaskFocus();
  });

  function initTextMaskFocus(){
    const nfTextInputs = document.querySelectorAll('.nf-field-element input[type="text"], .nf-field-element input[type="tel"]');
    if( nfTextInputs ){
      nfTextInputs.forEach(input => {
        input.addEventListener('focus', e => {
          setTimeout(item => {
            // Check if input value is only containing "_" characters 
            if( /^(_+)\1+$/.test(item.value) ){
              setTimeout(item => {
                item.selectionStart = 0;
                item.selectionEnd = 0;
              }, 25, item);
            }
          }, 10, e.target);
        });
      });
    }
  }

  function getCityFieldByZipcodeField(zipcode){
    const zipcodeParent = zipcode.closest('nf-field');

    if( !zipcodeParent ) return false;

    const city = zipcodeParent.nextElementSibling.querySelector('select');

    return city ? city : false;
  }

  function getZipcodeFieldByCityField(city){
    const cityParent = city.closest('nf-field');

    if( !cityParent ) return false;

    const zipcode = cityParent.previousSibling.querySelector('input');

    return zipcode ? zipcode : false;
  }

  function handleZipcodeChange(e){
    // Avoid double trigger on input unfocus/blur
    if( e.target != document.activeElement ) return;

    const citySelect = getCityFieldByZipcodeField(e.target);

    if( !citySelect ) return;

    const cleanValue = parseInt(e.target.value) ? String(parseInt(e.target.value)) : false;

    // Remove existing options
    const currentOptions = citySelect.querySelectorAll('option[name]');
    currentOptions.forEach(currentOption => citySelect.removeChild(currentOption));

    const citySelectContainer = citySelect.closest('.nf-field-container');

    // Trigger only if zipcode is long enough to avoid querying too many cities
    const MIN_ZIPCODE_LENGTH_AUTOCOMPLETE = 3;
    if( cleanValue.length < MIN_ZIPCODE_LENGTH_AUTOCOMPLETE ){
      // Reset previous timeout to prevent too many useless requests
      clearTimeout(document.zipcodeCityAutocompleteTimeout);
      if( citySelectContainer ){
        citySelectContainer.classList.add('disabled');
        citySelectContainer.classList.remove('loading');
      }
      return;
    }

    // Disable field when no options available
    if( citySelectContainer ){
      citySelectContainer.classList.add('disabled');
    }

    // Remove previous error
    const previousError = document.querySelector('.zipcode-custom-error');
    if( previousError ){
      previousError.remove();
    }

    // Do not execute search if zipcode value is not a number (for "_____" placeholder)
    if( !parseInt(e.target.value) ) return;

    if( citySelectContainer ){
      citySelectContainer.classList.add('loading');
    }

    // Reset previous timeout to prevent too many useless requests
    clearTimeout(document.zipcodeCityAutocompleteTimeout);

    // Recreate timeout with last input change value
    document.zipcodeCityAutocompleteTimeout = setTimeout(
      zipcodeInput => {

        const zipcode = zipcodeInput.value;
        getCitiesByZipcode(zipcode).then(cities => {
          let citiesFound = cities && cities.length;

          cities = cities.filter(city => {
            const cityZipcodes = city.codes_postaux.split(', ');
            let hasZipcodeStartingWithUserInput = false;

            cityZipcodes.forEach(cityZipcode => {
              if(String(cityZipcode).startsWith(cleanValue)){
                hasZipcodeStartingWithUserInput = true;
                return;
              }
            });

            return hasZipcodeStartingWithUserInput;
          });

          citiesFound = cities && cities.length;

          if( citySelectContainer ){
            citySelectContainer.classList.remove('loading');
            citySelectContainer.classList.toggle('disabled', !citiesFound);
          }
  
          if( !citiesFound ){
            // Display zipcode field error message
            const zipcodeInputParent = zipcodeInput.closest('nf-field');
            if( zipcodeInputParent ){
              const zipcodeAfterField = zipcodeInputParent.querySelector('.nf-error');
              if( zipcodeAfterField ){
                zipcodeAfterField.innerHTML = '<div class="nf-error-msg nf-error-required-error zipcode-custom-error" aria-live="assertive">Code postal inconnu.</div>';
              }
            }
  
            return;
          }
  
          // Add options to select list
          cities.forEach((city, i) => {
            const option = document.createElement('option');
            option.innerText = city.nom_standard;
            option.setAttribute('name', city.nom_standard);
            option.setAttribute('data-zipcode', city.code_postal);
            if( i == 0 ){
              option.setAttribute('selected', 'selected');
            }
            citySelect.append(option);
          });

          // Trigger jQuery change event to update select2 values
          $(citySelect).trigger('change');
        });
      },
      1000,
      e.target
    );

  }

  function handleCityChange(e){
    const zipcodeInput = getZipcodeFieldByCityField(e.target);

    if( !zipcodeInput || zipcodeInput.value.includes('_') ) return;

    const zipcode = e.target.options[e.target.selectedIndex].dataset.zipcode;
    if( zipcode && zipcodeInput.value != zipcode ){
      zipcodeInput.value = zipcode;
      $(zipcodeInput).trigger('change');
    }
  }

  function getCitiesByZipcode(zipcode){
    const params = new URLSearchParams({
      'codes_postaux__contains': zipcode,
      'columns': 'nom_standard, code_postal, codes_postaux',
    });

    return new Promise(resolve => fetch('https://tabular-api.data.gouv.fr/api/resources/f5df602b-3800-44d7-b2df-fa40a0350325/data/?' + params).then(response => {
      if( response.ok ){
        response.json().then(content => {
          resolve(content.data.length ?
            content.data.map(cityContent => {
              return 'nom_standard' in cityContent && 'code_postal' in cityContent ? cityContent : false;
            }).filter(Boolean)
            : null
          );
        });
      } else {
        resolve(null);
      }
    }));
  }


  function initZipcodeCityAutocomplete(){
    const zipcodeFields = document.querySelectorAll('.nf-field input[autocomplete="postal-code"]');

    if( !zipcodeFields ) return ;

    zipcodeFields.forEach(zipcodeField => {
      // Init event only on zipcode fields that has a city select field just after
      const cityField = getCityFieldByZipcodeField(zipcodeField);
      if( !cityField ) return;

      $(zipcodeField).on('change', handleZipcodeChange);
      $(zipcodeField).on('blur', () => { $(cityField).trigger('change'); });
      $(cityField).on('change', handleCityChange);

      // Initally trigger change event to clear select options and disable input
      $(zipcodeField).trigger('change');
    });
  }

  // Custom date picket
  if (typeof Marionette != "undefined") {

    var customDatePicker = Marionette.Object.extend({
      initialize: function () {
        this.listenTo(Backbone.Radio.channel('flatpickr'), 'init', this.modifyDatepicker);
      },
      onChange: function (selectedDates, dateStr, instance) {
        disableHour = false;
        $(selectedDates).each(function (index, date) {
          if (date.getDay() === 1) {
            disableHour = true;
          }
        });
        if (disableHour) {
          // Disable option
          if ($("#nf-field-96").val() == '09h00') {
            $("#nf-field-96").val('10h00');
          }
          $("#nf-field-96 option[value='09h00']").prop('disabled', true);
        } else {
          $("#nf-field-96 option[value='09h00']").prop('disabled', false);
        }
      },
      modifyDatepicker: function(dateObject, fieldModel) {
        if (fieldModel.attributes.formID == 7) {
          var proxy = this;
          var minDate = new Date();
          minDate.setDate(minDate.getDate() + 4);
          dateObject.set('minDate', minDate);
          dateObject.set('onChange', this.onChange);
          dateObject.set('disable', [function(date) {
            var year = date.getFullYear();
            var month = date.getMonth();
            var monthDay = date.getDate();
            var weekDay = date.getDay();
            var paquesDate = proxy.getDateFromEaster(year, 1);
            var ascensionDate = proxy.getDateFromEaster(year, 39);
            var pentecoteDate = proxy.getDateFromEaster(year, 50);
            $result = false;
            if (weekDay === 0 || weekDay === 6) { // Weekends
              $result = true;
            }
            else if (monthDay === 1 && month === 0) { // Jour de l'an
              $result = true;
            }
            else if (date.getTime() === paquesDate.getTime()) { // Lundi de Pâques
              $result = true;
            }
            else if (monthDay === 1 && month === 4) { // Fête du Travail
              $result = true;
            }
            else if (monthDay === 8 && month === 4) { // Victoire des alliés
              $result = true;
            }
            else if (date.getTime() === ascensionDate.getTime()) { // Jeudi de l'Ascension
              $result = true;
            }
            else if (date.getTime() === pentecoteDate.getTime()) { // Lundi de Pentecôte
              $result = true;
            }
            else if (monthDay === 14 && month === 6) { // Fête Nationale
              $result = true;
            }
            else if (monthDay === 15 && month === 7) { // Assomption
              $result = true;
            }
            else if (monthDay === 1 && month === 10) { // Toussaint
              $result = true;
            }
            else if (monthDay === 11 && month === 10) { // Armistice
              $result = true;
            }
            else if (monthDay === 25 && month === 11) { // Noël
              $result = true;
            }
            else if (year === 2025 && ( (month === 6 && monthDay >= 26) || (month === 7 && monthDay < 20) )) { // Summer 2025
              $result = true;
            }
            return $result;
          }]);
        }
      },

      getDateFromEaster(year, additionalDays) {
        var f = Math.floor,
            G = year % 19,
            C = f(year / 100),
            H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
            I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
            J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
            L = I - J,
            month = 3 + f((L + 40) / 44),
            day = L + 28 - 31 * f(month / 4);
        return new Date(year, month - 1, day + additionalDays);
      }
    });

    const customPhoneNumberValidation = Marionette.Object.extend({
      initialize: function() {
        // On the Form Submission's field validaiton...
        var submitChannel = Backbone.Radio.channel( 'submit' );
        this.listenTo( submitChannel, 'validate:field', this.validate );

        // on the Field's model value change...
        var fieldsChannel = Backbone.Radio.channel( 'fields' );
        this.listenTo( fieldsChannel, 'change:modelValue', this.validate );
      },
      
      validate: function( model ) {
        const lolaFormsPhoneNumberIds = [59, 64, 76, 86];
        const fieldId = model.get('id');

        if( !lolaFormsPhoneNumberIds.includes(fieldId) ){
          return;
        }

        const value = model.get('value');
        const errorId = 'phone-is-not-mobile';
        const fieldsChannel = Backbone.Radio.channel('fields');

        if( !String(value).startsWith('06') && !String(value).startsWith('07') ){
          
          // Add Error
          fieldsChannel.request(
            'add:error',
            fieldId,
            errorId,
            'Veuillez renseigner un numéro commençant par "06" ou "07"'
          );
        } else {
          fieldsChannel.request( 'remove:error', fieldId, errorId );
        }
      }
    });

    new customDatePicker();
    new customPhoneNumberValidation();
  }
});
